import { TViewDishAction, ViewDishActionTypes } from './viewDishActions';
import { IViewDishState } from './viewDishContext';

export const viewDishReducer = (state: IViewDishState, action: TViewDishAction): IViewDishState => {
	switch (action.type) {
		case ViewDishActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ViewDishActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case ViewDishActionTypes.REFETCH_PORTIONS_DATA:
			return {
				...state,
				needRefetchRestaurantPortionsData: action.payload.needRefetchRestaurantPortionsData,
			};
		case ViewDishActionTypes.SET_DISH_FULL_INFO:
			return {
				...state,
				dishFullInfo: action.payload.dishFullInfo,
				accessibleRestaurants: action.payload.accessibleRestaurants,
				accessiblePortionsRestaurants: action.payload.accessiblePortionsRestaurants,
			};
		case ViewDishActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS:
			return {
				...state,
				restaurantIdForRestaurantProps: action.payload.restaurantIdForRestaurantProps,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewDishActionTypes.SET_RESTAURANT_PROPS:
			return {
				...state,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewDishActionTypes.SET_RESTAURANT_ID_FOR_PORTIONS:
			return {
				...state,
				restaurantIdForPortions: action.payload.restaurantIdForPortions,
				restaurantPortions: action.payload.restaurantPortions,
			};
		case ViewDishActionTypes.SET_RESTAURANT_PORTIONS:
			return {
				...state,
				restaurantPortions: action.payload.restaurantPortions,
			};
		case ViewDishActionTypes.CHANGE_SELECTED_PORTION_ID:
			return {
				...state,
				selectedPortionId: action.payload.selectedPortionId,
			};
		case ViewDishActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case ViewDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
